export { setLocationData, getLocationData, getBrowserLocation, getBrowserLocationPermission } from './location';
export { pruneObject, transformGeoPlaceObject } from './transformation';
export { getCanonicalSearchUrl } from './url';
export { storeQuery } from './localStorage';
export { addCheckToSuggestion, parseHistorySuggestions, getLocationSuggestions, parseLocationResponse } from './suggestions';
export { setAction, getAction, cleanAction } from './userActionCookieHelper';
/*
 * @param tagType -- string -- oneOf([CATEGORY_TAG_TYPE, FORMAT_TAG_TYPE])
 * @param tags array
 *
 * Returns first tag that matches passed in type
 */

export var findTagByType = function findTagByType(tagType, tags) {
  return tags.find(function (tag) {
    return tag.indexOf(tagType) > -1;
  });
};